var render = function render(){var _vm=this,_c=_vm._self._c;return (!this.isLoading)?_c('div',{staticClass:"news-card-list"},[_c('NewsCard',{attrs:{"viewModel":this.items[0]}}),_c('NewsCard',{attrs:{"viewModel":this.items[1]}}),_c('NewsCard',{attrs:{"viewModel":this.items[2]}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }